import React from "react";

interface CustomCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
}

export default function CustomCheckbox({
  id,
  checked,
  onChange,
  label,
  className = "",
  size = "md",
  disabled = false,
}: CustomCheckboxProps) {
  // Size configurations
  const sizeConfig = {
    sm: {
      container: "w-5 h-5",
      checkmark: "w-3 h-3 top-1 left-1",
      label: "text-sm",
    },
    md: {
      container: "w-7 h-7",
      checkmark: "w-4 h-4 top-1.5 left-1.5",
      label: "text-sm",
    },
    lg: {
      container: "w-9 h-9",
      checkmark: "w-5 h-5 top-2 left-2",
      label: "text-base",
    },
  };

  const config = sizeConfig[size];

  return (
    <div className={`flex items-center ${className}`}>
      <div className="relative">
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
          disabled={disabled}
        />
        <label
          htmlFor={id}
          className={`
            block ${config.container} border-2 border-brand-brand_purple rounded-full transition-all duration-200 mb-4
            ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
          `}
        >
          {/* purple checkmark */}
          <div
            className={`
              absolute ${config.checkmark} transition-opacity duration-200 
              ${checked ? "opacity-100" : "opacity-0"}
            `}
          >
            <svg
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-full h-full"
            >
              <path
                d="M3 8L7 12L13 4"
                stroke="#6E35FF"
                strokeWidth="3"
                strokeLinecap="square"
                strokeLinejoin="bevel"
              />
            </svg>
          </div>
        </label>
      </div>
      {label && (
        <label
          htmlFor={id}
          className={`ml-2 ${config.label} font-medium text-gray-900 mb-4 ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
        >
          {label}
        </label>
      )}
    </div>
  );
}
